module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail-winner/home-main-modal-detail-winner.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail-winner/home-main-modal-detail-winner.component.sass
// module chunks = main